import moment from "moment";
import { httpRequest_002 } from "../../Server/Axios";
import * as XLSX from "xlsx";

export const summaryGridColumn = [
  { field: "A_Id", headerName: "ID", flex: 0.5 },
  {
    field: "A_Date",
    headerName: "Date",
    flex: 1,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  { field: "A_LocName", headerName: "Location", flex: 2 },
  { field: "A_Narr", headerName: "Narration", flex: 3 },
  { field: "A_Status", headerName: "Status", flex: 2 },
  // { field: "Status_Name", headerName: "Status", flex: 2 },
];

export const exportToExcel = (
  data,
  fileName = "data",
  sheetName = "Sheet1"
) => {
  const workSheet = XLSX.utils.json_to_sheet(data);
  const workBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);
  XLSX.writeFile(workBook, `${fileName}.xlsx`);
};

export const ITEMSREQAConfirmSummaryAPI = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/ITEMSREQAConfirmSummary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const ITEMSREQLoadAPI = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/ITEMSREQLoad`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const ItemRequestFieldSearchAPI = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/ItemRequestFieldSearch`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const ItemCreationRejectionReasonsAPI = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/ItemCreationRejectionReasons`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const ITEMSREQPostANDRejectAPI = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/ITEMSREQPostANDReject`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const ItemReqGetRowExportAPI = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/ItemReqGetRowExport`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
